import React from 'react';
import { useState, useEffect } from 'react';
import '../App.css';
import './cookoff.css';
import { Form, Icon, Message } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import { storageUtils } from '../utils/localStorage';
import LoadingScreen from './LoadingScreen';

// https://form.typeform.com/to/j5wUjmvL#chilliname=xxxxx&useremail=xxxxx&chilliid=xxxxx
export default function Judges() {
  const [userEmail, setUserEmail] = useState('');
  const [userName, setUserName] = useState();
  const [userLoggedIn, setuserLoggedIn] = useState(false);
  const [completedItems, setcompletedItems] = useState([]);
  const [showLoadingScreen, setShowLoadingScreen] = useState(false);

  const [showMessage, setShowMessage] = useState();

  // const userEmail = 'dom@test.com';
  let chilliName = 'default';

  const logIn = () => {
    console.log('login', userEmail);
    if (userEmail !== '') {
      // Show loading screen for new users
      setShowLoadingScreen(true);

      // Hide loading screen after 4.5 seconds
      setTimeout(() => {
        setShowLoadingScreen(false);
      }, 4500);

      storageUtils.setUser(userEmail);

      console.log('---> users name: ', userName);

      storageUtils.setUserName(userName);
      setuserLoggedIn(true);
    }
  };

  const putItemsInLocalStorage = (item) => {
    console.log('!!!! >>>> putItemsInLocalStorage CALLED');

    // Use the utility function to add the item
    const updatedItems = storageUtils.addCompletedItem(item);

    // Update state
    setcompletedItems(updatedItems);

    console.log('Ive updated completed items');
    setTimeout(() => {
      console.log('completedItems update in state... ', completedItems);
      console.log(
        'Current year completed items:',
        storageUtils.getCompletedItems(),
      );
    }, 3000);
  };

  const setChilliName = (value) => {
    chilliName = value;
    console.log('chilliname is now', chilliName);
  };

  // ALL
  // Table #	Name	Chili Name	Email	Group
  // 1	Oscar	4300 North	oscaror9254@gmail.com	Red
  // 2	Michael Perrino	Abigail's Wrath	Mperrino7@aol.com	Orange
  // 3	Jourdan O'Connor	The Wicked Witch's Brew	jourdan.thunberg@gmail.com	Green
  // 4	Zach Johnson	Business Trip	zacharyjohnson1718@gmail.com	Gold
  // 5	Jason Smith	Red Hot Chili Peppers 	Jason.woodpro@gmail.com	Red
  // 6	Megan Garrity	Chief Garrity Firehouse Favorite	marymeg7780@gmail.com	Orange
  // 7	Becky Coakley	Chili Man! Chili!  	BCoakley@leyden212.org	Green
  // 8	Jessie O'Connor	Chili Nelson	jessoconnor94@gmail.com	Gold
  // 9	Mark Parcel	Chilly Willy Nilly Chili	vaughnparcels@aol.com	Red
  // 10	JJ & Blanche	Coffee Talk Chili	dublj95@aol.com	Orange
  // 11	Katie Roeder	Da Chili	kroeder@fastenal.com	Green
  // 12	Bob Roybal	Uncle Baby Birdee’s 2.0	sanfordansons@yahoo.com	Gold
  // 13	Dylan and Steph Teeter	Mean Jean	Sjeangoggin@gmail.com	Red
  // 14	Tim Meyers 	Meyers Mayhem	timeyers4@gmail.com	Orange
  // 15	Bill Forsberg	Not To Chili!	Billforsberg303@gmail.com	Green
  // 16	Jimmy Buczynski	Pol-Ski’s Chili	jbucktuna@aol.com	Gold

  // END OF ALL
  const listOfChillis = [
    { id: '1', name: 'Oscar', c: '4300 North' },
    { id: '2', name: 'Michael Perrino', c: "Abigail's Wrath" },
    {
      id: '3',
      name: "Jourdan O'Connor",
      c: "The Wicked Witch's Brew",
    },
    { id: '4', name: 'Zach Johnson', c: 'Business Trip' },
    { id: '5', name: 'Jason Smith', c: 'Red Hot Chili Peppers' },
    {
      id: '6',
      name: 'Megan Garrity',
      c: 'Chief Garrity Firehouse Favorite',
    },
    { id: '7', name: 'Becky Coakley', c: 'Chili Man! Chili!' },
    { id: '8', name: "Jessie O'Connor", c: 'Chili Nelson' },
    { id: '9', name: 'Mark Parcel', c: 'Chilly Willy Nilly Chili' },
    { id: '10', name: 'JJ & Blanche', c: 'Coffee Talk Chili' },
    { id: '11', name: 'Katie Roeder', c: 'Da Chili' },
    { id: '12', name: 'Bob Roybal', c: 'Uncle Baby Birdee’s 2.0' },
    { id: '13', name: 'Dylan and Steph Teeter', c: 'Mean Jean' },
    { id: '14', name: 'Tim Meyers', c: 'Meyers Mayhem' },
    { id: '15', name: 'Bill Forsberg', c: 'Not To Chili!' },
    { id: '16', name: 'Jimmy Buczynski', c: 'Pol-Ski’s Chili' },
  ];

  // Kept for reference when preparing future cookoff lists.
  // eslint-disable-next-line no-unused-vars
  const listOfChillisOLD = [
    { id: '1', name: 'Bill Meyers Chili', c: "Billi's Chilli" },
    // { id: '2', name: 'Jamie Mendoza Chili', c: 'Brown Chicken Brown Cow' },

    { id: '2', name: 'Katie Qs Chili', c: 'Quintessential Q Chili' },

    { id: '3', name: 'Orlando Chili', c: 'Chilling Me Softly' },
    {
      id: '4',
      name: 'Mark Parcel Chili',
      c: "Grammy's Smack Your Lips Chilli",
    },
    { id: '5', name: 'Katie Roeder Chili', c: 'Ham Bam Thank You Yam!' },
    { id: '6', name: "JJ O'Connor Chili", c: 'Jack in the Pot' },
    {
      id: '7',
      name: 'Joey Calzante Chili',
      c: 'Leave The Gun, Take The Chili',
    },
    { id: '8', name: 'Stephanie Teeter Chili', c: 'Mean Jean' },
    { id: '9', name: 'Matt Shepherd Chili', c: 'Mom and Pop’s' },
    { id: '10', name: 'Vanessa Hastings Chili', c: 'The Canadian' },
    { id: '11', name: 'Franco Calzante Chili', c: 'Not your Abuelas Chili' },
    {
      id: '12',
      name: 'Michael Perrino Chili',
      c: 'Chili While Camping, it’s Intents',
    },
    { id: '13', name: 'Natalie Lavalee Chili', c: 'Slow Burn' },
    { id: '14', name: 'Jourdan O’Connor', c: 'Minute To Win It' },
    {
      id: '15',
      name: 'Bob Roybal Chili',
      c: 'Uncle Baby Birdee’s Bayou Batch',
    },
    { id: '16', name: 'Jason Smith Chili', c: 'Wood Pros Chili' },
  ];

  const signUserOut = () => {
    console.log('signUserOut');
    setUserName(undefined);
    setUserEmail('');
    setcompletedItems([]); // Clear state

    // Clear user data but leave completed items (they're year-specific now)
    storageUtils.clearUser();

    setuserLoggedIn(false);
    setShowMessage('logout');
  };

  useEffect(() => {
    console.log('useEffect');
    const user = storageUtils.getUser();
    const userName = storageUtils.getUserName();

    if (user) {
      console.log('email is here in local storage');
      setUserEmail(user);

      if (userName) {
        setUserName(userName);
      }

      setuserLoggedIn(true);
    }

    // Get completed items for current year
    const completedItemsForYear = storageUtils.getCompletedItems();
    if (completedItemsForYear.length > 0) {
      console.log(
        `USE EFFECT: This user has voted for items in ${storageUtils.getCurrentYear()}. Setting state`,
      );
      setcompletedItems(completedItemsForYear);

      setTimeout(() => {
        console.log(
          'USE EFFECT: completedItems update in state... ',
          completedItemsForYear,
        );
      }, 3000);
    }

    console.log(
      `completedItems for ${storageUtils.getCurrentYear()} >>`,
      completedItemsForYear,
    );

    const query = new URLSearchParams(window.location.search);
    console.log('url parameters', query);
    console.log(`window.location.search ${window.location.search}`);
    const completed = query.get('completed');
    console.log('completed url parameter: ', completed);

    if (completed) {
      console.log('there is an chili id in completed.', completed);
      putItemsInLocalStorage(completed);
    }

    const userEmailWhoCompletedGrading = query.get('ue');
    console.log(`userEmailWhoCompletedGrading ${userEmailWhoCompletedGrading}`);

    const signout = query.get('signout');
    if (signout === 'true') {
      console.log('there is a parameter in the URL to log out.');
      signUserOut();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <LoadingScreen
        isVisible={showLoadingScreen}
        subtitle="Get ready to score some amazing chilis!"
      />

      <main className="App-header cookoff-page">
        <div
          className={userLoggedIn ? 'content cookoff-content-wide' : 'content'}
        >
          <div className="top-half"></div>

          <div className="cookoff-badge-wrap">
            <img
              className="cookoff-badge"
              src="hot-pepper.png"
              alt="Hot pepper icon"
              width="240"
              height="240"
            ></img>
          </div>

          <div className="cookoff-intro">
            <h1 className="cookoff-title">Judges Scoring</h1>
            {userLoggedIn && (
              <p className="cookoff-subtitle">
                Judges, please score each chilli below.
              </p>
            )}
          </div>

          {!userLoggedIn && (
            <div className="cookoff-login">
              <p className="cookoff-login-prompt">
                Judges, enter your email to get started.
              </p>

              <div className="login-form-container cookoff-form">
                <Form onSubmit={logIn}>
                  <Form.Field>
                    <label htmlFor="cookoff-name">Full Name</label>
                    <input
                      id="cookoff-name"
                      placeholder="Full Name"
                      autoComplete="name"
                      onChange={(event) => setUserName(event.target.value)}
                    />
                  </Form.Field>
                  <Form.Field>
                    <label htmlFor="cookoff-email">Email</label>
                    <input
                      id="cookoff-email"
                      placeholder="BiebsWasHere@gmail.com"
                      inputMode="email"
                      autoComplete="email"
                      autoCapitalize="none"
                      autoCorrect="off"
                      spellCheck={false}
                      onChange={(event) => setUserEmail(event.target.value)}
                    />
                  </Form.Field>

                  <div className="cookoff-actions">
                    <button className="email-btn" type="submit">
                      Start
                    </button>
                  </div>
                  {/* <Button type='submit'>Submit</Button> */}
                </Form>
              </div>
            </div>
          )}

          {userLoggedIn && (
            <ul className="cookoff-list">
              {listOfChillis.map(function (item, id) {
                const typeformUrl =
                  'https://form.typeform.com/to/j5wUjmvL#chilliid=' +
                  item.id +
                  '&useremail=' +
                  userEmail +
                  '&username=' +
                  userName;
                const isDone = completedItems.includes(item.id);

                return (
                  <li
                    className={
                      isDone ? 'cookoff-card is-done' : 'cookoff-card'
                    }
                    key={item.id}
                  >
                    <a
                      className="cookoff-card-link"
                      href={typeformUrl}
                      onClick={() => {
                        setChilliName(item.id);
                      }}
                    >
                      <span className="cookoff-pot">
                        {isDone ? (
                          <img
                            src="pot-icon-done.png"
                            alt="Completed pot icon"
                            width="300"
                            height="272"
                          ></img>
                        ) : (
                          <img
                            src="pot-icon.png"
                            alt="Pot icon"
                            width="300"
                            height="272"
                          ></img>
                        )}
                        <span className="cookoff-pot-number">{item.id}</span>
                      </span>
                      <span className="cookoff-card-name">Chili #{item.id}</span>
                      {isDone ? (
                        <span className="cookoff-card-done" aria-hidden="true">
                          ✅
                        </span>
                      ) : (
                        <span
                          className="cookoff-card-chevron"
                          aria-hidden="true"
                        ></span>
                      )}
                    </a>
                  </li>
                );
              })}
            </ul>
          )}

          {showMessage === 'logout' && (
            <Message color="blue" className="cookoff-notice cookoff-logout">
              {/* <p style={{ fontSize: 13 }}> */}
              Logged out. Please log back in with the same email you used last
              time
              {/* </p> */}
            </Message>
          )}

          <footer className="cookoff-footer">
            {userLoggedIn && userEmail && (
              <p className="cookoff-account">
                Logged in as {userName} ({userEmail})
              </p>
            )}
            <Link
              to="/settings"
              className="cookoff-settings"
              aria-label="Settings"
            >
              <Icon name="setting" />
            </Link>
          </footer>
        </div>
      </main>
    </>
  );
}
